import { TirsPolygoneEnum } from "src/app/bo/polygon/tirPolygoneEnum";

export class CarteHelpers{

   static enumToNumber(enumObj: any):number {
        const stringValue = Object.keys(TirsPolygoneEnum).find(key => TirsPolygoneEnum[key] === enumObj);
         const enumsKeys =  Object.keys(TirsPolygoneEnum);
         let index = -1;
         enumsKeys.forEach((v,i,a)=>{
          if(v == stringValue){
            index= i;
          }
         })
         return index;
      }
}